import { DatePipe } from '@angular/common';
import { inject, Injectable, Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

export type LocaleDateFormat = 'long';

@Injectable({ providedIn: 'root' })
@Pipe({
  name: 'localeDate',
  pure: false,
})
export class LocaleDatePipe implements PipeTransform {
  private readonly datePipe = new DatePipe('en');
  private readonly translate = inject(TranslateService);

  transform(value: string | Date | null | undefined, format?: LocaleDateFormat): string {
    if (value === null || value === undefined || value === '') {
      return '';
    }

    const date = value instanceof Date ? value : new Date(value);

    if (isNaN(date.getTime())) {
      return '';
    }

    const lang = this.translate.getCurrentLang() ?? this.translate.getFallbackLang() ?? 'en';
    return this.datePipe.transform(date, this.getFormat(lang, format)) ?? '';
  }

  private getFormat(lang: string, format?: LocaleDateFormat): string {
    const withTime = format === 'long';
    switch (lang) {
      case 'no': return withTime ? 'dd.MM.yyyy HH:mm' : 'dd.MM.yyyy';
      case 'se': return withTime ? 'yyyy-MM-dd HH:mm' : 'yyyy-MM-dd';
      case 'da': return withTime ? 'dd-MM-yyyy HH:mm' : 'dd-MM-yyyy';
      case 'fi': return withTime ? 'dd.MM.yyyy HH:mm' : 'dd.MM.yyyy';
      default:   return withTime ? 'dd/MM/yyyy HH:mm' : 'dd/MM/yyyy';
    }
  }
}
